import React from "react";
import BaseIcon from "./base";

const AddedDoc = (props) => {
	return (
		<BaseIcon {...props}>
			<path d="M16,14 L2,14 C1.448,14 1,13.552 1,13 C1,12.448 1.448,12 2,12 L16,12 C16.552,12 17,12.448 17,13 C17,13.552 16.552,14 16,14 Z M16,10 L2,10 C1.448,10 1,9.552 1,9 C1,8.448 1.448,8 2,8 L16,8 C16.552,8 17,8.448 17,9 C17,9.552 16.552,10 16,10 Z M16,6 L2,6 C1.448,6 1,5.552 1,5 C1,4.448 1.448,4 2,4 L16,4 C16.552,4 17,4.448 17,5 C17,5.552 16.552,6 16,6 Z M2,16 L12,16 C12.552,16 13,16.448 13,17 C13,17.552 12.552,18 12,18 L2,18 C1.448,18 1,17.552 1,17 C1,16.448 1.448,16 2,16 Z M19.493,20.536 C19.343,20.762 19.106,20.918 18.839,20.966 C18.78,20.976 18.721,20.982 18.662,20.982 C18.453,20.982 18.247,20.915 18.076,20.79 L15.4,18.839 C14.956,18.515 14.859,17.892 15.183,17.448 C15.507,17.004 16.131,16.908 16.575,17.231 L18.408,18.568 L21.134,14.46 C21.438,14.001 22.056,13.876 22.515,14.18 C22.973,14.484 23.098,15.101 22.794,15.559 L19.493,20.536 Z" />
		</BaseIcon>
	);
};

export default AddedDoc;
